/* QUIETUDE — barre de consentement.

   Shopify n'expose la Customer Privacy API qu'apres loadFeatures : tant qu'elle n'est
   pas chargee, window.Shopify.customerPrivacy n'existe pas. Rien ne s'affiche avant
   sa reponse — une barre qui apparait puis disparait parce que le visiteur avait deja
   choisi est pire que pas de barre du tout.

   ?qt_consent=force affiche la barre sans rien demander a l'API. C'est ce qui permet
   de la voir alors qu'un choix a deja ete enregistre dans le navigateur. */
(function () {
  var root = document.getElementById('qt-consent');
  if (!root) return;

  var FORCE = location.search.indexOf('qt_consent=force') !== -1;
  var panel = root.querySelector('.qtc-panel');
  var prefsBtn = root.querySelector('[data-qtc="prefs"]');
  var lastFocus = null;

  function publishHeight() {
    var h = root.getAttribute('data-state') === 'hidden' ? 0 : root.offsetHeight;
    document.documentElement.style.setProperty('--qt-consent-h', h + 'px');
  }

  function setState(state) {
    root.setAttribute('data-state', state);
    if (prefsBtn) prefsBtn.setAttribute('aria-expanded', state === 'panel' ? 'true' : 'false');
    if (state === 'panel') {
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('role', 'dialog');
    } else {
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('role');
    }

    /* Deux publications, et la premiere n'est pas une precaution de style.

       requestAnimationFrame ne se declenche pas tant que la page n'est pas rendue :
       onglet ouvert en arriere-plan, prerender, fenetre masquee. La barre s'affichait
       alors sans jamais publier sa hauteur, --qt-consent-h restait vide, et le bouton
       d'ajout au panier ne se decalait pas — il passait sous la barre sur telephone.

       La lecture synchrone de offsetHeight force le calcul de la mise en page et donne
       tout de suite la bonne valeur. Le rAF qui suit ne sert qu'a la corriger si le
       navigateur ajuste encore quelque chose apres coup. */
    publishHeight();
    requestAnimationFrame(publishHeight);
  }

  function hide() {
    setState('hidden');
    document.documentElement.style.setProperty('--qt-consent-h', '0px');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function write(consent) {
    var cp = api();
    if (!cp) { hide(); return; }
    cp.setTrackingConsent(consent, function () { hide(); });
  }

  function openPanel() {
    setState('panel');
    var first = panel.querySelector('input:not([disabled])');
    if (first) first.focus();
  }

  /* Le panneau rouvert depuis le pied de page doit montrer les choix deja faits,
     pas deux interrupteurs eteints : sinon le visiteur croit avoir tout refuse. */
  function syncSwitches() {
    var cp = api();
    var current = cp && cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
    if (!current) return;
    var boxes = root.querySelectorAll('[data-qtc-signal]');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = current[boxes[i].getAttribute('data-qtc-signal')] === 'yes';
    }
  }

  function readSwitches() {
    var out = { preferences: true };
    var boxes = root.querySelectorAll('[data-qtc-signal]');
    for (var i = 0; i < boxes.length; i++) {
      out[boxes[i].getAttribute('data-qtc-signal')] = boxes[i].checked;
    }
    out.sale_of_data = !!out.marketing;
    return out;
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qtc]');
    if (!btn) return;
    var action = btn.getAttribute('data-qtc');

    if (action === 'accept') {
      write({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
    } else if (action === 'decline') {
      /* preferences reste vrai : la langue et la devise memorisees sont exemptees de
         consentement, et sans elles le selecteur de pays oublie le visiteur a chaque page. */
      write({ analytics: false, marketing: false, preferences: true, sale_of_data: false });
    } else if (action === 'prefs') {
      lastFocus = btn;
      openPanel();
    } else if (action === 'save') {
      write(readSwitches());
    }
  });

  /* Le bouton du pied de page vit hors de la barre : son ecoute est posee sur le
     document, pas sur root. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qtc-reopen]');
    if (!btn) return;
    e.preventDefault();
    lastFocus = btn;
    syncSwitches();
    openPanel();
  });

  /* Echap ferme le panneau et rend la barre, sans rien ecrire : fermer n'est pas choisir. */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.getAttribute('data-state') === 'panel') {
      setState('bar');
      if (prefsBtn) prefsBtn.focus();
      return;
    }
    if (e.key !== 'Tab' || root.getAttribute('data-state') !== 'panel') return;

    var items = root.querySelectorAll('button, [href], input:not([disabled])');
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('resize', publishHeight);

  /* Qui decide de l'affichage.

     shouldShowBanner() ne repond vrai que dans les regions configurees par le reglage
     du bandeau Shopify — celui-la meme qu'on desactive en posant cette barre. S'y fier
     seul, c'est faire dependre notre bandeau d'un reglage qu'on vient d'eteindre : il
     ne se serait plus jamais affiche, nulle part.

     La regle est donc l'etat du consentement, que Shopify tient a jour quoi qu'il
     arrive : les quatre signaux valent '' tant que le visiteur n'a rien choisi, puis
     'yes' ou 'no'. Tant qu'ils sont vides, la barre s'affiche. Une fois le choix fait,
     elle ne revient plus — et le lien du pied de page reste la pour en changer.

     Consequence assumee : elle s'affiche partout, pas seulement dans l'Union. C'est le
     choix prudent, et celui que fait la majorite des boutiques qui vendent hors zone.

     shouldShowBanner() ne peut PAS decider seul de rouvrir la barre. Mesure du
     04/09/2026 depuis la France : il repond vrai alors que les quatre signaux valent
     deja 'yes'. La condition « jamaisChoisi || regionDemande » rouvrait donc la barre
     a CHAQUE page pour un visiteur ayant deja tout accepte — le pire des deux mondes,
     illisible comme consentement et insupportable a l'usage. Il ne sert plus que dans
     le seul cas ou il apporte quelque chose : un consentement partiel. */
  function decide() {
    if (FORCE) { setState('bar'); return; }
    var cp = api();
    if (!cp) return;

    var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
    if (!c) return;

    /* Chaque signal vaut '' tant que le visiteur n'a rien dit, puis 'yes' ou 'no'. */
    var signaux = [c.analytics, c.marketing, c.preferences, c.sale_of_data];
    var renseignes = 0;
    for (var i = 0; i < signaux.length; i++) { if (signaux[i]) renseignes++; }

    if (renseignes === 0) { setState('bar'); return; }
    if (renseignes === signaux.length) return;

    var regionDemande = typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner();
    if (regionDemande) setState('bar');
  }

  /* Le pied de page doit pouvoir rouvrir le choix : pouvoir revenir sur son consentement
     est une obligation, pas un confort. On expose un objet neuf — ne jamais envelopper
     window.qtOpenCart, qui est un accesseur pose par fly-to-cart et part en recursion. */
  window.qtConsent = {
    openPreferences: function () {
      lastFocus = document.activeElement;
      syncSwitches();
      openPanel();
    },
    close: hide
  };

  if (FORCE) {
    decide();
  } else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) { if (!error) decide(); }
    );
  }
})();